import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CheckoutSummary" })
export default class CheckoutSummary extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {};
    public checkoutSummary: any = null;
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();

        this.showPaymentDescription(this.checkoutSummary.cartDetail.paymentMethod);
    }

    public async getData() {
        this.checkoutSummary = (await Axios.post(this.routes.Checkout_GetCheckoutSummaryData)).data;
    }

    public showPaymentDescription(payment: string) {
        var customerPayTypeDescription = $("#CustomerPayTypeDescription");
        var wiretransferDescription = $("#WireTransferDescription");

        if (payment === "Customer") {
            customerPayTypeDescription.show();
            wiretransferDescription.hide();
        } else if (payment === "WireTransfer") {
            customerPayTypeDescription.hide();
            wiretransferDescription.show();
        } else if (payment === "PayPal") {
            customerPayTypeDescription.hide();
            wiretransferDescription.hide();
        }
    }

    public async updateShippingCosts(shippingType: string) {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.Checkout_SetShippingType, { shippingType: shippingType })).data;

            await this.getData();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async updatePaymentCosts(paymentmethod: string) {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.Checkout_SetPaymentMethod, { paymentmethod: paymentmethod })).data;

            await this.getData();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.showPaymentDescription(paymentmethod);

        this.isLoading = false;
    }

    public async setCouponCode() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.Cart_SetCouponCode, { couponCode: this.checkoutSummary.cartDetail.couponCode })).data;

            await this.getData();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
        this.isLoading = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.Checkout_Summary, this.formData)).data;

            GTagHelper.sendEvent("click", "place_order");
            
            this.isSuccess = true;

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};